import { Box, styled } from '@planne-software/uni/mui/material';

export const SequentialSlotHighlightFrame = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'highlighted',
})<{ highlighted?: boolean }>(({ theme, highlighted }) => ({
  width: '100%',
  borderRadius: theme.tokens.radius['border-radius-xs'],
  transition: 'box-shadow 0.15s ease-out',
  boxShadow: highlighted ? `${theme.tokens.effects['ring-secondary-inner-shadow']}` : 'none',
}));
